import * as Yup from 'yup';
import { Validator } from '../../shared/constants/validator';

type TranslateFunction = (key: string) => string;

export const createContactUsValidationSchema = (t: TranslateFunction) =>
    Yup.object({
        name: Yup.string()
            .required(t('contactUs.REQUIRED_NAME'))
            .min(Validator.minLengthName, t('contactUs.INVALID_NAME'))
            .max(Validator.maxLengthName, t('contactUs.INVALID_NAME')),

        company: Yup.string()
            .min(Validator.minLengthName, t('contactUs.INVALID_COMPANY'))
            .max(Validator.maxLengthName, t('contactUs.INVALID_COMPANY')),

        email: Yup.string().required(t('contactUs.REQUIRED_EMAIL')).email(t('contactUs.INVALID_EMAIL')),

        phone: Yup.string().matches(Validator.phoneNumberRegExp, t(Validator.translateMainCode + 'PHONE_NUMBER')),

        postalCode: Yup.string()
            .required(t('contactUs.REQUIRED_ZIP'))
            .max(Validator.maxLengthName, t('contactUs.INVALID_ZIP')),

        country: Yup.string().required(t('contactUs.REQUIRED_COUNTRY')),

        message: Yup.string()
            .required(t('contactUs.REQUIRED_MESSAGE'))
            .max(Validator.textAreaLengthLimit, t('contactUs.INVALID_MESSAGE')),
    });
